import empty from "../../assets/empty.png"

const Empty = () => {
  return (
    <div className="">
      <img src={empty} className="m-auto" alt="empty cart" />
      <p className="text-center">You have no item in cart</p>
    </div>
  );
};

export default Empty;
